export const weeklySubscriptionJob = `
  query WeeklySubscriptionJob($jobId: String!) {
    weeklySubscriptionJob(jobId: $jobId) {
      jobId
      status
      message
      sent
      failed
      error
    }
  }
`;
